function buildQueryPath(params) {
  const queryParams = [];
  params.forEach((param) => {
    if (param.value) {
      queryParams.push(`${param.key}=${param.value}`);
    }
  });
  return queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
}

/** @return {string} */
export function ANNOUNCEMENT_URL() {
  return '/api/announcements';
}

/** @return {string} */
export function BFY_URL() {
  return '/api/bfys';
}

/** @return {string} */
export function HEALTH_CHECK_URL() {
  return '/api/healthcheck';
}

/** @return {string} */
export function ORG_SUMMARY_URL(bfy = null, orgId = null, page = null, resultsPerPage = null) {
  const params = [{
    key: 'bfy',
    value: bfy,
  }, {
    key: 'orgId',
    value: orgId,
  }, {
    key: 'page',
    value: page,
  }, {
    key: 'resultsPerPage',
    value: resultsPerPage,
  }];
  return `/api/org-summary${buildQueryPath(params)}`;
}

/** @return {string} */
export function ORG_SUMMARY_PROGRAM_URL(bfy = null, orgId = null) {
  const params = [{
    key: 'bfy',
    value: bfy,
  }, {
    key: 'orgId',
    value: orgId,
  }];
  return `/api/org-summary/programs${buildQueryPath(params)}`;
}

/** @return {string} */
export function PROGRAM_ALLOCATION_URL(allocationId = null, bfy = null, programId = null) {
  const params = [{
    key: 'bfy',
    value: bfy,
  }, {
    key: 'programId',
    value: programId,
  }];
  let url = '/api/program-allocations';
  url = allocationId ? `${url}/${allocationId}` : url;
  return `${url}${buildQueryPath(params)}`;
}

/** @return {string} */
export function PROGRAM_URL(programId, bfy) {
  return `/api/programs/${programId}?bfy=${bfy}`;
}

/** @return {string} */
// eslint-disable-next-line max-len
export function PROGRAM_SUMMARY_URL(bfy = null, programId = null, page = null, resultsPerPage = null) {
  const params = [{
    key: 'bfy',
    value: bfy,
  }, {
    key: 'programId',
    value: programId,
  }, {
    key: 'page',
    value: page,
  }, {
    key: 'resultsPerPage',
    value: resultsPerPage,
  }];
  return `/api/program-summary${buildQueryPath(params)}`;
}
